<template>


	<div class="booking-mask__wrap">

		<div class="booking-mask">

			<h2 class="booking-mask__title">{{msg.find_accommodation}}</h2>

			<div class="booking-mask__datepicker">

				<label class="booking-mask__datepicker-title booking-mask__datepicker-title--v-separator">{{msg.select_dates}}:</label>
				<!-- <HotelDatePicker format="DD/MM/YYYY"></HotelDatePicker> -->
				<date-picker></date-picker>
				
			</div>

			<!-- <div class="booking-mask__dropdown">
				<label class="booking-mask__dropdown-title">Guests:</label>
				<input @click="showDropdown = !showDropdown" class="c-select-dropdown__trigger" readonly="true" type="text" name="" v-model="guests">

				<div class="c-select-dropdown">
					<ul class="c-select-dropdown__list" v-show="showDropdown">
						<li class="c-select-dropdown__list-item">
							<span class="c-select-dropdown__list-subitem" :class="{'js-active': guests == 1}" @click="changeGuests">1</span>
							<span class="c-select-dropdown__list-subitem" :class="{'js-active': guests == 2}" @click="changeGuests">2</span>
							<span class="c-select-dropdown__list-subitem" :class="{'js-active': guests == 3}" @click="changeGuests">3</span>
							<span class="c-select-dropdown__list-subitem" :class="{'js-active': guests == 4}" @click="changeGuests">4</span>
							<span class="c-select-dropdown__list-subitem" :class="{'js-active': guests == 5}" @click="changeGuests">5</span>
						</li>
					</ul>
				</div>
			</div> -->


			<popper trigger="click" :options="{placement: 'bottom-end', modifiers: { offset: { offset: '50px, 30px' } }}"
					@show="popperShow = true"
					@hide="popperShow = false"
					>
				<div class="popper-sidebar popper-sidebar--guests">

					<div class="popper-sidebar__item">
						<label class="popper-sidebar__item-label">{{msg.booking_adults}}:</label>
						<div class="popper-sidebar__item-buttons-wrap">
							<button :disabled="adults < 2" :class="{'button-disabled' : adults < 2}" class="popper-sidebar__item-button" v-on:click="decrementAdults">-</button>
							<div class="popper-sidebar__item-counter">{{ adults }}</div>
							<button class="popper-sidebar__item-button" v-on:click="incrementAdults">+</button>
						</div>
					</div>

					<div class="popper-sidebar__item">
						<label class="popper-sidebar__item-label">{{msg.booking_children}}:</label>
						<div class="popper-sidebar__item-buttons-wrap">
							<button :disabled="!children.length" :class="{'button-disabled' : !children.length}" class="popper-sidebar__item-button" v-on:click="removeChild">-</button>
							<div class="popper-sidebar__item-counter">{{ children.length }}</div>
							<button class="popper-sidebar__item-button" v-on:click="addChild">+</button>
						</div>
					</div>

					<div v-if="children.length" class="popper-sidebar__item">
						<h3 class="popper-sidebar__item-title">{{msg.booking_child_age}}</h3>
					</div>

					<div v-for="(child, index) in children" :key="index" class="popper-sidebar__item">
							<label class="popper-sidebar__item-label">{{msg.booking_child}} {{index + 1}}:</label>
							<div class="popper-sidebar__item-buttons-wrap">
								<!-- <multiselect :options="childAges" v-model="child.age" :searchable="false" :close-on-select="true" :show-labels="false"></multiselect> -->
							</div>
					</div>

				</div>
				
				<div class="booking-mask__dropdown" slot="reference">
					<label class="booking-mask__dropdown-title">{{msg.booking_guests}}:</label>
					<div v-show="adults > 0" class="booking-mask__dropdown-value-wrap">
						<span class="booking-mask__dropdown-value">{{ adults }}</span> <span v-if="children.length" class="booking-mask__dropdown-value"> + {{ children.length }}</span>
					</div>
				</div>

			</popper>


			<div class="booking-mask__input-container">
				
					<input class="booking-mask__input" type="text" id="promo-code" name="promo-code"
					size="10" :placeholder="msg.booking_mask_promo" v-model="promoCode">

					<input class="booking-mask__input" type="text" id="corporate-id" name="corporate-id"
					size="10" :placeholder="msg.booking_mask_corpo" v-model="corporateId">

			</div>

			<a :href="searchUrl" class="booking-mask__btn btn btn-primary btn-primary--invert" @click="search">{{msg.search}}</a>

		</div>
		
	</div>

</template>
<script>
// import HotelDatePicker from 'vue-hotel-datepicker';
import Popper from 'vue-popperjs';
import { mapState } from "vuex";
import { eventBus } from '../main.js';
import Multiselect from 'vue-multiselect';

export default {
	components: {
		// HotelDatePicker,
		'popper': Popper,
		Multiselect
	},
	data: () => ({
		guests: 1,
		adults: 1,
		dates: [],
		showDropdown: false,
		popperShow: false,
		promoCode: '',
		corporateId: '',
		children: [],
		defaultChild: {
			age: 0
		},
		childAges: Array.apply(null, {length: 17}).map(Number.call, Number),
		searchUrl: "",
	}),
	props: {
		endpoint: String
	},
	created() {
		eventBus.$on('date-changed', payload => {
			this.dates = payload;
		});
		this.dates.push(new Date());
		let today = new Date();
		let tomorrow = new Date();
		tomorrow.setDate(today.getDate()+1);
		this.dates.push(tomorrow);
	},
	mounted() {
		let self = this;

		window.addEventListener('click', function(e){
			// console.log(e.target, 'click');
			// close dropdown when clicked outside
			if (!e.target.classList.contains('c-select-dropdown__trigger')) {
				// console.log('entered');
				self.showDropdown = false;
			} 
		});
	},
	methods: {
		addChild() {
			this.children.push(_.cloneDeep(this.defaultChild));
		},
		removeChild() {
			this.children.pop();
		},
		search() {
			let dd = this.dates[0].getDate();
			let mm = this.dates[0].getMonth()+1;
			let yyyy = this.dates[0].getFullYear();
			let arrival = mm + "." + dd + "." + yyyy;

			dd = this.dates[1].getDate();
			mm = this.dates[1].getMonth()+1;
			yyyy = this.dates[1].getFullYear();
			let departure = mm + "." + dd + "." + yyyy;

			let promoCode = this.promoCode;
			let corporateId = this.corporateId;

			let childAgeString = '';
			this.children.forEach(child => {
				childAgeString += child.age + '|';
			});

			childAgeString = childAgeString.slice(0, childAgeString.length - 1);
			// console.log(childAgeString, this.children);

			this.searchUrl = this.endpoint + "&adult=" + this.adults + "&Child=" + this.children.length + "&childages=" + childAgeString + "&arrive=" + arrival + "&Depart=" + departure + "&Promo=" + promoCode + "&corporateid=" + corporateId;
			// window.location.href = this.endpoint + "&adult=" + this.adults + "&Child=" + this.children + "&childages=" + childAgeString + "&arrive=" + arrival + "&Depart=" + departure + "&Promo=" + promoCode + "&corporateid=" + corporateId;

			console.log(this.searchUrl);
		},
		changeGuests(event) {
			// console.log(event.target.innerHTML);
			this.guests = event.target.innerHTML;
		},
		activateDropdown() {
			this.showDropdown = true;
		},
		incrementAdults() {
			this.adults++;
		},
		decrementAdults() {
			this.adults--;
		},
		incrementChildren() {
			this.children++;
		},
		decrementChildren() {
			this.children--;
		},
	},
	computed: {
		...mapState({
			msg: state => state.msg,
		})
	}

};
</script>
<style>
</style>